module.exports = "<app-legal-menu></app-legal-menu>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/legal/legal.component.html
// module id = ./src/app/legal/legal.component.html
// module chunks = main